import React from "react";
import { Outlet } from "react-router-dom";
import bothstores from "../logos/bothstores.jpg";
import paymethod from "../logos/paymethod.png";
import { Link } from "react-router-dom";
class Footer extends React.Component {
  render() {
    return (
      <section>
        <section id="newsletter" className="section-p1 section-m1">
          <div className="newstext">
            <h4>Sign Up for Newsletters</h4>
            <p>
              Get E-mail Updates about our letter shop and
              <span> Special offers.</span>
            </p>
          </div>
          <form onSubmit={(e) => e.preventDefault()} className="form">
            <input type="email" placeholder="Your Email address" required />
            <button className="normal">Sign Up</button>
          </form>
        </section>
        <footer className="section-p1">
          <div className="col">
            <h4>Contact</h4>
            <p>
              <strong>Address:</strong> 562 Wellington Road, Street 32, San
              Francisco
            </p>
            <p>
              <strong>Hours:</strong>10:00 -18:00, Mon - Sat
            </p>
            <div className="follow">
              <h4>Follow Us</h4>
              <div className="icon">
                <a href="https://github.com/sarmad426">
                  <i className="fab fa-facebook-f facebook"></i>
                </a>
                <a href="https://github.com/sarmad426">
                  <i className="fab fa-twitter twitter"></i>
                </a>
                <a href="https://github.com/sarmad426">
                  <i className="fab fa-instagram instagram"></i>
                </a>
                <a href="https://github.com/sarmad426">
                  <i className="fab fa-pinterest-p pintrest"></i>
                </a>
                <a href="https://github.com/sarmad426">
                  <i className="fab fa-youtube youtube"></i>
                </a>
              </div>
            </div>
          </div>
          <div className="col">
            <h4>About</h4>
            <Link to="/about">About Us</Link>
            <Link to="/about">Privacy Policy</Link>
            <Link to="/about">Terms & Conditions</Link>
            <Link to="/help">Help</Link>
            <Link className="link" to="/businessaccount">
              Become a seller
            </Link>
            <Link className="link" to="/mylist">
              My List
            </Link>
          </div>
          <div className="col">
            <h4>My Account</h4>
            <Link to="/login">Sign in</Link>
            <Link to="/cart">View Cart</Link>
            <Link to="/wishlist">My Wishlist</Link>
            <Link to="/shipped" className="link">
              Track My Order
            </Link>

            <Link to="/upcoming" className="link">
              Upcoming Products
            </Link>
          </div>
          <div className="col install">
            <h4>Install App</h4>
            <p>From App Store or Google Play</p>
            <div className="row">
              <img src={bothstores} alt="" />
            </div>
            <p>Secured Payment Gateways</p>
            <img src={paymethod} alt="" />
          </div>
          <div className="copyright">
            <p>&copy; 2022, Tech2 etc - #Always Be Progressive</p>
          </div>
        </footer>
        <Outlet />
      </section>
    );
  }
}
export default Footer;
